import type { ComponentStyleConfig } from '@chakra-ui/theme';

const ModalCloseButton: ComponentStyleConfig = {
  baseStyle: {
    borderRadius: '50%',
  },
  variants: {},
  defaultProps: {},
};

export default ModalCloseButton;
